import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import RouteNotFound from '../../RouteNotFound';
import ModelScenariosViews from './ModelScenariosViews';
import ScenarioPage from './ScenarioPage';
import ScenarioViewPage from './ScenarioViewPage';

const ModelScenariosHome = () => {
  const match = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${match.path}`}>
        <ModelScenariosViews />
      </Route>
      <Route path={`${match.path}/:id/view`} component={ScenarioViewPage} />
      <Route path={`${match.path}/:scenarioKey`} component={ScenarioPage} />
      <Route path="*">
        <RouteNotFound />
      </Route>
    </Switch>
  );
};
export default ModelScenariosHome;
